import types from "./types";
import { ThunkDispatch } from "redux-thunk";
import api from "constants/api";
import _get from "lodash/get";

export interface PowerBIProviderModel {
  provKeyIds: string[];
}

export const getAccessToken =
  () => (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.GET_POWERBI_TOKEN_REQUEST });

    return api.powerBI
      .getAccessToken()
      .then((res: any) => {
        dispatch({
          type: types.GET_POWERBI_TOKEN_SUCCESS,
          payload: res,
        });

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.GET_POWERBI_TOKEN_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
  };

export const getPowerBIProvider =
  (payload: PowerBIProviderModel) =>
  (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch({ type: types.GET_POWERBI_PROVIDER_REQUEST, payload });

    return api.powerBI
      .getProviders(payload)
      .then((res: any) => {
        dispatch({
          type: types.GET_POWERBI_PROVIDER_SUCCESS,
          payload: res,
        });

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, "response.data.msg", "Get failed!");
        const errors = _get(err, "response.data.errors", {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.GET_POWERBI_PROVIDER_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
  };
